import type { ConfigureStoreOptions } from '@reduxjs/toolkit';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer from '../auth/store/reducers/auth.slice';
import creativeStepSliceReducer from '../editor/store/reducers/creative-step.slice';
import editorModalsDrawersReducer from '../editor/store/reducers/modals-drawers.slice';
import propertyInfoSliceReducer from '../editor/store/reducers/property-info.slice';
import editorActivePlatformsReducer from '../editor/store/reducers/selected-platforms.slice';
import adSetStepSliceReducer from '../editor/store/reducers/adSet-step.slice';
import { api } from '@/shared/services/api/api';
import { rtkQueryErrorLogger } from '@/shared/services/middleware/RTQ.error-logger.middleware';
import { loadStateFromLocalStorage } from '@/store/localStorage-hydration.service';
import { hydrateFromLocalStorage } from '@/editor/store/actions/hydration.action';

export const rootReducer = combineReducers({
  authReducer,
  editorActivePlatformsReducer,
  adSetStepSliceReducer,
  editorModalsDrawersReducer,
  creativeStepSliceReducer,
  propertyInfoSliceReducer,
  api: api.reducer,
});

export const createStore = (options?: ConfigureStoreOptions['preloadedState']) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware).concat(rtkQueryErrorLogger),
    ...options,
  });

export const store = createStore();

const persistedState = loadStateFromLocalStorage();

if (persistedState) {
  store.dispatch(hydrateFromLocalStorage(persistedState));
}

export type RootReducer = ReturnType<typeof rootReducer>;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof createStore>;
export type AppDispatch = typeof store.dispatch;
